import React from 'react';
import { MapIcon, LayoutListIcon, CompassIcon } from 'lucide-react';
import { Section, SectionHeader } from './ui/Section';
import { pillars } from '../data/content';
const icons = [MapIcon, LayoutListIcon, CompassIcon];
export function SolutionSection() {
  return <Section className="py-14 sm:py-16 lg:py-20" data-id="element-129" data-mp="3o6xt88my3pah">
      <SectionHeader title={<>
            No necesitás que alguien organice el viaje por vos.{' '}
            <span className="text-caribe" data-id="element-131" data-mp="139uj7c8frul">Necesitás saber cómo organizarlo.</span>
          </>} intro="La guía te acompaña desde las primeras decisiones hasta los últimos preparativos, para que puedas diseñar un viaje que tenga sentido según tus días, tu presupuesto y tu forma de viajar." data-id="element-130" data-mp="3j9605bakdx4p" />

      <ul className="mt-9 grid grid-cols-1 gap-3.5 sm:mt-12 sm:grid-cols-3 sm:gap-4" data-id="element-132" data-mp="5wcecnr7jmxl">
        {pillars.map((pillar, index) => {
        const Icon = icons[index];
        return <li key={pillar.label} className="flex h-full flex-col items-center rounded-xl border border-oceano/10 bg-white px-5 py-7 text-center" data-id="element-133" data-mp="ftqt8ixhg3ns" data-mpi={index}>
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-caribe/10" data-id="element-134" data-mp="36c6ur0zjnwwj">
                <Icon className="h-5 w-5 text-caribe" strokeWidth={1.7} aria-hidden="true" data-id="element-135" data-mp="3ba8n6civ18ko" />
              </span>
              <h3 className="mt-4 font-display text-[21px] font-bold uppercase leading-none tracking-[0.02em] text-oceano" data-id="element-136" data-mp="3fdetfk5z2zr5">
                {pillar.label}
              </h3>
              <p className="mt-3 font-sans text-[12.5px] leading-relaxed text-hierro sm:text-[13px]" data-id="element-137" data-mp="3p8ow8a473b5z">
                {pillar.text}
              </p>
            </li>;
      })}
      </ul>

      <p className="mx-auto mt-9 max-w-[38rem] text-center font-sans text-[13px] leading-relaxed text-oceano/70 sm:mt-11 sm:text-[13.5px]" data-id="element-138" data-mp="2uyg0q045d61">
        La idea no es darte un itinerario obligatorio. Es darte mejores herramientas para construir el
        tuyo.
      </p>
    </Section>;
}